import { api } from "../api";

export interface Collection {
  id: string;
  tenantId: string;
  name: string;
  code?: string | null;
  description?: string | null;
  isActive: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreateCollectionDto {
  name: string;
  code?: string;
  description?: string;
  isActive?: boolean;
}

export type UpdateCollectionDto = Partial<CreateCollectionDto>;

export const collectionsApi = {
  /**
   * Get all collections for the current tenant (authenticated)
   */
  getAll: async (includeInactive = false): Promise<Collection[]> => {
    const response = await api.get("/collections", {
      params: { includeInactive },
    });
    return response.data;
  },

  /**
   * Get a single collection by ID
   */
  getById: async (id: string): Promise<Collection> => {
    const response = await api.get(`/collections/${id}`);
    return response.data;
  },

  /**
   * Create a new collection
   */
  create: async (data: CreateCollectionDto): Promise<Collection> => {
    const response = await api.post("/collections", data);
    return response.data;
  },

  /**
   * Update an existing collection
   */
  update: async (id: string, data: UpdateCollectionDto): Promise<Collection> => {
    const response = await api.put(`/collections/${id}`, data);
    return response.data;
  },

  /**
   * Delete a collection
   * @param id - Collection ID
   * @param hardDelete - If true, permanently delete. If false or undefined, soft delete (set inactive).
   */
  delete: async (id: string, hardDelete?: boolean): Promise<void> => {
    const params = hardDelete ? { hardDelete: "true" } : {};
    await api.delete(`/collections/${id}`, { params });
  },
};
